import { render, staticRenderFns } from "./ResponseIcon.vue?vue&type=template&id=2bc60859&"
import script from "./ResponseIcon.vue?vue&type=script&lang=js&"
export * from "./ResponseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports